/*
  Subscription topics
*/
export const WS_SESSION = 'WS_SESSION'

export const AUTHORIZED_CLIENT_UPDATES = 'AUTHORIZED_CLIENT_UPDATES'

export const REALITY_CHECK_PING = 'REALITY_CHECK_PING'

/*
  Client balance update

  @example data {
    balance: 10834006,
    detailedBalance: {
      BONUS: 3,
      CLIENT_HOLD: 15600,
      CLIENT_PROFIT: -856083,
      HOLD: 0,
      CASH: 10834006
    }
  }
*/
export const CLIENT_BALANCE = 'CLIENT_BALANCE'

/*
Client bonus messages
*/
export const CLIENT_BONUS_ACTIVATE = 'CLIENT_BONUS_ACTIVATE'
export const CLIENT_BONUS_DEACTIVATE = 'CLIENT_BONUS_DEACTIVATE'
export const CLIENT_BONUS_STATUS = 'CLIENT_BONUS_STATUS'
export const CLIENT_BONUS_ELIGIBILITY_STATUS = 'CLIENT_BONUS_ELIGIBILITY_STATUS'

/*
  Client deposit complete event

  @example data {
    amount: 1000
    currency: "USD"
    paymentMethodId: "5"
    paymentMethodName: "skrill"
  }
*/

export const CLIENT_BETS_COUNT = 'CLIENT_BETS_COUNT'
export const CLIENT_BET_UPDATE = 'CLIENT_BET_UPDATE'

/*
  Client deposit complete event

  @example data {
    FAILED:11,
    WIN:14,
    UNSETTLED:62,
    LOSE:21,
    CANCELLED:19
  }
*/
export const DEPOSIT_COMPLETE = 'DEPOSIT_COMPLETE'

/*
  Provider status update

  @example data {
    feedName: "lsport",
    status: "ONLINE"
  }
*/
export const GLOBAL_STATUS_UPDATES = 'GLOBAL_STATUS_UPDATES'

/*
  @example data {
    id: -1, <- subscriptionKey -1 means all sports
    data: {
      id: 3, <- sportId
      prematchCount: 127,
      liveCount: 4
    }
  }
*/
export const SPORT_EVENT_COUNT = 'SPORT_EVENT_COUNT'

/*
  @example data {
    id: 3, <- subscriptionKey sportId
    data:{
      id: 1290, <- categoryId
      prematchCount: 4,
      liveCount: 1
    }
  }
*/
export const CATEGORY_EVENT_COUNT = 'CATEGORY_EVENT_COUNT'

/*
  @example data {
    id: 1290, <- subscriptionKey categoryId
    data: {
      id: 2361, <- tournamentId
      prematchCount: 0,
      liveCount: 1
    }
  }
*/
export const TOURNAMENT_EVENT_COUNT = 'TOURNAMENT_EVENT_COUNT'

/*
  Experimental topics
*/
export const EXPERIMENTAL_EVENT = 'EXPERIMENTAL_EVENT'
export const EXPERIMENTAL_TOURNAMENT = 'EXPERIMENTAL_TOURNAMENT'

/*
  Update for event to switch sport service
  Handlers on this topic usually adding or removing sport event in tournament scope
  @example data {
    "tournamentId": 8253,
    "events": {
      "48649": {
        "id": 48649,
        "sportService": "UNSPECIFIED" / LIVE
      }
    }
  }
*/
export const TOURNAMENT_SPORT_SERVICE_UPDATE = 'TOURNAMENT_SPORT_SERVICE_UPDATE'

/*
  Subscription for place bet success result event

  @example data {
    clientId: 7304,
    bets: [
      {
        updatedBy: null,
        amount: 100,
        odds: 3.5,
        betType: SINGLE,
        bonusInfo: null,
        rollBackTime: null,
        createTime: 1584632526634,
        billingTransactionId: 801179,
        estimatedCashOut: null,
        originalBetId: null,
        updateTime: 1584632526634,
        resettleTime: null,
        acceptOddsChanges: YES,
        maxBetAmount: 100000,
        oddsLimit: null,
        betMoney: {
          betAmount: 100,
          betAmountFC: 100,
          betAmountWithoutTaxFC: null,
          winAmount: null,
          winAmountFC: null,
          liabilityWithoutTax: null,
          currency: EUR,
          betTaxPercentage: null,
          betAmountWithoutTax: null,
          payout: null,
          payoutFC: null,
          winTaxPercentage: null,
          liabilityFC: 250,
          liability: 250,
          liabilityWithoutTaxFC: null
        },
        requestId: 29398,
        clientId: 7304,
        editBetAllowed: null,
        settleTime: null,
        betId: 370017,
        outcome: {
          outcomeInfo: {
            outcomeName: Western Sydney Wanderers FC,
            eventName: Western Sydney Wanderers FC vs. Sydney FC,
            marketName: 1x2,
            tournamentName: A-League,
            sportId: 2,
            categoryName: Australia,
            eventId: 337368,
            outcomeStatus: NOT_DEFINED,
            categoryId: 1283,
            tournamentId: 2138,
            marketId: 23863192,
            sportName: Soccer,
            sportService: PREMATCH
          },
          odds: 3.5,
          incomeOdds: 3.5,
          outcomeId: 33214869
        },
        cashOutReason: null,
        estimatedPartialCashOut: null,
        betStatus: UNSETTLED
      }
    ],
    placeBetRequestId: ae083213
  }
*/
// export const PLACE_BET_SUCCESS_RESULT = 'PLACE_BET_SUCCESS_RESULT'
export const PLACE_BET_REQUEST_RESULT = 'PLACE_BET_REQUEST_RESULT'

/*
  Subscription for place bet fail result event

  @example data {
    "clientId": 7304,
    "placeBetRequestId": "278f3341-3101-42e6-80c0-35a9fd446297",
    "errors": [
      {
        "requestId": 10678,
        "betDto": {
          "betId": 372789,
          "clientId": 7304,
          "requestId": 10678,
          "betType": "SINGLE",
          "acceptOddsChanges": "NO",
          "acceptParameterChanges": null,
          "bonusInfoList": [],
          "odds": 1.95,
          "oddsLimit": null,
          "betStatus": "UNSETTLED",
          "settleTime": null,
          "resettleTime": null,
          "rollBackTime": null,
          "updatedBy": null,
          "createTime": null,
          "updateTime": null,
          "billingTransactionId": null,
          "betMoney": {
            "currency": "EUR",
            "betAmount": 500000,
            "betAmountFC": null,
            "betAmountWithoutTax": null,
            "betAmountWithoutTaxFC": null,
            "betTaxPercentage": null,
            "liability": 475000,
            "liabilityFC": null,
            "winAmount": null,
            "winAmountFC": null,
            "liabilityWithoutTax": null,
            "liabilityWithoutTaxFC": null,
            "winTaxPercentage": null,
            "payout": null,
            "payoutFC": null
          },
          "maxBetAmount": 263157,
          "originalBetId": null,
          "cashOutReason": null,
          "estimatedCashOut": null,
          "estimatedPartialCashOut": null,
          "editBetAllowed": null,
          "outcome": {
            "outcomeId": "515901",
            "outcomeInfo": {
              "outcomeName": "Bate Borisov 0.25",
              "eventId": "14305",
              "eventName": "Slavia Mozyr vs Bate Borisov",
              "marketId": "198101",
              "marketName": "Handicap",
              "sportId": "1",
              "sportName": "Football",
              "categoryId": "1",
              "categoryName": "Belarus",
              "tournamentId": "206",
              "tournamentName": "Belarusian Cup",
              "sportService": "PREMATCH",
              "outcomeStatus": "NOT_DEFINED"
            },
            "odds": 1.95,
            "incomeOdds": 1.95
          },
          "amount": 500000
        },
        "violations": [
          {
            "code": "MAX_BET_AMOUNT_EXCEEDED",
            "message": "Bet amount - [500000] exceeds max limit - [263157.89473684214]",
            "violationInfo": {
              "maxBetAmount": 263157.89473684214,
              "maxBetPerCombinationAmount": 263157.89473684214
            }
          }
        ]
      }
    ]
  }

  @example data {
    clientId: 7304,
    placeBetRequestId: "baf6d9af-a1a5-4574-bdaf-493abc76c4f2",
    code: "NOT_ENOUGH_FUNDS",
    message: "Not enough funds on ledger 7304 account 'CASH' (required at least 300 actual 124)",
  }
*/
export const PLACE_BET_FAIL_RESULT = 'PLACE_BET_FAIL_RESULT'

/*
  Racing WebSocket Topics
*/
export const RACING_ANY_RACE_STATUS_UPDATE = 'RACING_ANY_RACE_STATUS_UPDATE'
export const RACING_RACE_UPDATE = 'RACING_RACE_UPDATE'
